import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./quotation_form.css";
import AppSteps from "../../../component/app_steps/app_steps2";
import AppModal from "../../../component/app_modal/app_modal";
import AppStandardDetailsCard from "../../../component/app_quotation_card/app_standard_details_card";
import AppGeneratedDocumentsDetailsCard from "../../../component/app_quotation_card/app_generated_documents_card2";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import QuotationBloc from "../../../../bloc/quotation_bloc";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import ProposalBloc from "../../../../bloc/mrtt_proposal_bloc";

const StepData = [
    {
        title: 'Personal Details',
        status: 'process'
    },
    {
        title: 'Financing Details',
        status: 'process'
    },
    {
        title: 'Takaful Details',
        status: 'process'
    },
    {
        title: 'Review and Submit'
    },
]

class ReviewSubmitQuotation extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            keyword: null,
            name: null,
            gender: null,
            idType: null,
            nricNo: null,
            otherICNo: null,
            dob: null,
            age: 0,
            occupation: null,
            smokerStatus: null,
            dateOfQuotation: null,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            isSuccessModalOpen: false,
        };
    }

    getQuotationID() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.getQuotationData();
    }

    async getQuotationData() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let quotationDetails = await QuotationBloc.getQuotationDetail(this.getQuotationID(), userData.username); //'SHA002'

        this.setState({
            loading: false,
            formDetails: quotationDetails,
        })
    }

    async getSelectedBank() {
        let selectedBank = await JSON.parse(sessionStorage.getItem("selectedBank"))?.id || this.props?.userGlobal?.roles[0]?.entity;
        if (selectedBank !== 'MBS' && this.stateFormDetails()?.financialDetails?.sourceChannel) {
            selectedBank = this.stateFormDetails().financialDetails.sourceChannel;
        }
        return selectedBank;
    }

    companyNameByEntity = async () => {
        if (this.props.userGlobal) {
            switch (this.props?.userGlobal?.roles[0]?.entity || await this.getSelectedBank()) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    stateModule() {
        return "quotation";
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleSuccessModalOpen = () => {
        this.setState({ isSuccessModalOpen: true })
    }
    handleSuccessModalClose = () => {
        this.setState({ isSuccessModalOpen: false })
    }

    handleGoBackToDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`
    }

    async handleGoCreateProposal() {
        let result = await ProposalBloc.createNewProposal({ id: this.getQuotationID(), sourceChannel: await this.getSelectedBank() });
        if (result.success) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${result.data[0].proposal.id}`
        } else {
            this.setState({
                title: 'Notification',
                message: result.message,
                isOpen: true,
            })
        }
    }

    handleGoQuotationDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    handleNextStep() {
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_review_submit}`
    }

    async handleFormSubmit() {
        this.setState({ loading: true });
        let result = await QuotationBloc.generateQuotation(this.getQuotationID());
        if (result.success) {
            this.setState({ loading: false });
            this.handleSuccessModalOpen();
        }

    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={true}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Create Quotation'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleFormSubmit() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={3}
                                    items={StepData}
                                />
                            </div>

                        </App_header>
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 90,
                                fontFamily: 'Lato'
                            }}
                        >
                            {this.state.loading && this.loadingContent()}
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={'Step 4 - Review and Submit'}
                                    description={'Please fill in the details and ensure the information you provided is correct'}
                                />
                            </div>
                            <div className="w-100 px-3 pb-4">
                                {this.stateFormDetails()?.personalDetails && (
                                    <AppStandardDetailsCard
                                        data={this.stateFormDetails().personalDetails}
                                        fields={
                                            Config.quotation.dataDetailMapping.personalDetails ||
                                            []
                                        }
                                        header={this.stateFormDetails().personalDetails.caption}
                                    />
                                )}

                                {this.stateFormDetails()?.financialDetails && (
                                    <AppStandardDetailsCard
                                        data={this.stateFormDetails()?.financialDetails}
                                        fields={
                                            Config.quotation.dataDetailMapping.financialDetails ||
                                            []
                                        }
                                        header={this.stateFormDetails()?.financialDetails.caption}
                                    />
                                )}
                                {this.stateFormDetails()?.takafulDetails && (
                                    <AppStandardDetailsCard
                                        data={this.stateFormDetails().takafulDetails}
                                        // data={}
                                        fields={
                                            Config.quotation.dataDetailMapping.takafulDetails ||
                                            []
                                        }
                                        header={this.stateFormDetails().takafulDetails.caption}
                                    />
                                )}
                                {this.stateFormDetails()?.generatedDocuments && (
                                    <AppGeneratedDocumentsDetailsCard
                                        module={this.stateModule()}
                                        data={this.stateFormDetails().generatedDocuments}
                                    />
                                )}
                            </div>

                        </div>
                        {this.renderBottomBar()}
                        <AppModal
                            open={this.state.isSuccessModalOpen}
                            // handleModalClose={this.handleSuccessModalClose}
                            width={'50%'}
                            title={'Quotation creation successful!'}
                            subtitle={'A quotation has been created. Click on “Proceed to Proposal” if you want to continue creating proposal from this quotation.'}
                            negativeButtonText={'Back to Dashboard'}
                            positiveButtonText={'Proceed to Proposal'}
                            handleNegativePress={() => this.handleGoBackToDashboard()}
                            handlePositivePress={() => this.handleGoCreateProposal()}
                            customButton={true}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.isSaveModalOpen}
                            handleModalClose={this.handleSaveModalClose}
                            width={'50%'}
                            title={'Do you want to stop?'}
                            subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={() => this.handleGoQuotationDashboard()}
                            handlePositivePress={() => this.handleGoQuotationDashboard()}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.isDiscardModalOpen}
                            handleModalClose={this.handleDiscardModalClose}
                            width={'50%'}
                            title={'Do you want to discard?'}
                            subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={this.handleGoQuotationDashboard}
                            handlePositivePress={this.handleGoQuotationDashboard}
                            closable={false}
                        />
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ReviewSubmitQuotation));
